export enum LeaderboardPageType {
  TRENDING = "trending",
  HOLDING = "holding",
  WATCHLIST = "watchlist",
}
